import { useState } from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function ProviderContactDrawer({
  open,
  setOpen,
  register,
  watch,
  onAddContact,
}) {
  const formValues = watch();

  const onSave = () => {
    // Send new contact to parent using newContactName and newContactEmail
    if (formValues.newContactName && formValues.newContactEmail) {
      onAddContact({
        name: formValues.newContactName,
        email: formValues.newContactEmail,
      });
    }
    setOpen(false);
  };
  const onCancel = () => {
    setOpen(false);
  };
  return (
    <Dialog open={open} onClose={setOpen} className="relative z-50">
      <div className="fixed inset-0 bg-transparent bg-opacity-40 backdrop-blur-sm backdrop-filter transition-opacity duration-500 ease-in-out" />

      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
            <DialogPanel
              transition
              className="pointer-events-auto w-screen max-w-2xl transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
            >
              <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                <div className="px-4 sm:px-6">
                  <div className="flex items-start justify-between">
                    <DialogTitle className="text-base font-semibold text-gray-900">
                      New Vendor Contact
                      <p className="text-sm text-gray-500 font-thin mt-3">
                        Add a secondary vendor contact by filling in the form
                        below.
                      </p>
                    </DialogTitle>
                    <div className="ml-3 flex h-7 items-center">
                      <button
                        type="button"
                        onClick={() => setOpen(false)}
                        className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      >
                        <span className="absolute -inset-2.5" />
                        <span className="sr-only">Close panel</span>
                        <XMarkIcon aria-hidden="true" className="size-6" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="relative mt-6 flex-1 px-4 sm:px-6">
                  {/* Your content */}
                  <div>
                    <div className="flex flex-col space-y-8 border-b border-gray-300  py-5">
                      <span className="space-x-3 flex items-center justify-between">
                        <label className="text-sm font-semibold">
                          Contact Name
                        </label>
                        <input
                          placeholder="Enter Contact Name"
                          type="text"
                          {...register("newContactName")}
                          className="ring-0 border-gray-300 rounded-md text-sm  w-[300px] lg:w-[400px] xl:w-[450px] "
                        />
                      </span>
                    </div>
                    <div className="flex flex-col space-y-8 py-5">
                      <span className="space-x-3 flex items-center justify-between ">
                        <label className="text-sm font-semibold">Email</label>
                        <input
                          placeholder="Enter Email"
                          type="text"
                          {...register("newContactEmail")}
                          className="ring-0 border-gray-300 rounded-md text-sm  w-[300px] lg:w-[400px] xl:w-[450px] "
                        />
                      </span>
                    </div>
                  </div>
                </div>
                <div className="mt-28 flex items-center justify-end gap-x-6 border-t py-2 px-5">
                  <button
                    type="button"
                    onClick={onCancel} // Trigger form reset
                    className="text-sm font-semibold leading-6 text-gray-900"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={onSave} // Store form values
                    type="submit"
                    className="inline-flex justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    Save
                  </button>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
